import React, { createRef } from 'react';
import axios, { subscribeShopDataSyncState } from '../modules/api';
import {http, setIsErrorAlert} from '../modules/api';
import $ from 'jquery';
import "react-datepicker/dist/react-datepicker.css";
import SaveDialogV2 from '../modules/dialogs/SaveDialogV2';
import BasicDialogV2 from '../modules/dialogs/BasicDialogV2';
import TitleContentDialogV2 from '../modules/dialogs/TitleContentDialogV2';
import ConfirmDialogV2 from '../modules/dialogs/ConfirmDialogV2';

import round_loading_bar from '../../resources/img/round_loading_bar.gif';

import WarningDialog from '../modules/dialogs/WarningDialog';
import moment from 'moment';
import LazyLoad from 'react-lazyload';
import InputDialogV2 from '../modules/dialogs/InputDialogV2';

import * as StringUtil from '../modules/utils/StringUtil';
import {RpOrderHourStatisticsHourlyFilter} from './RpOrderHourStatisticsHourlyFilter';
import Tooltip from '../modules/common/Tooltip';


export class RpOrderHourStatistics extends React.Component {
    constructor(props) {
        super(props);

        // 어제 날짜 기준으로 초기화
        const yesterday = new Date();
         yesterday.setDate(yesterday.getDate() - 1);
         yesterday.setHours(0, 0, 0, 0);
 
         const startHour = new Date(yesterday);
         const endHour = new Date(yesterday);
         endHour.setHours(23, 59, 59, 0);

        this.state = {
            list: [], // 시간대별 데이터 리스트
            totalAmount: 0, // 전체 매출 합계
            totalCount: 0, // 총 시간대 수
            page: 1, // 현재 페이지
            pageSize: 18, // 시간대별 최대 (6시 ~ 23시)
            totalPage: 1, // 총 페이지 수
            loading: false, // 로딩 상태
            orderDate: yesterday, // 선택된 날짜 (디폴트 어제)
            startHour: startHour.getHours(),
            endHour: endHour.getHours(),

            order_gubun: "order_hour", // 초기 정렬 기준
            order_type: "ASC",         // 초기 정렬 방향
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.loadHourlyStats();
    }

    componentDidUpdate(prevProps, prevState) {
    }

    componentWillUnmount(e) {
    }

    loadHourlyStats = async () => {
        const { orderDate, startHour, endHour, order_gubun, order_type } = this.state;
    
        if (!orderDate) return;
    
        this.setState({ loading: true });
    
        try {
            const response = await http.get("/rest/orderStatsHourly", {
                params: { 
                    orderDate: StringUtil.formatKSTDate(orderDate),
                    startHour,
                    endHour,
                    order_gubun,
                    order_type 
                }
            });
    
            const data = response.data;
    
            this.setState({
                list: data.list || [],
                totalAmount: data.totalAmount || 0,
                loading: false
            });
        } catch (error) {
            console.error("시간대별 통계 API 오류:", error);
            this.setState({ loading: false });
        }
    };
    
    handleFilterChange = (filters) => {
        this.setState({ 
            orderDate: filters.orderDate, 
            startHour: filters.startHour.getHours(),
            endHour: filters.endHour.getHours(), 
        }, this.loadHourlyStats);
    };

    downloadOrderStatsHourlyExcel = async () => {
        const { orderDate, startHour, endHour, order_gubun, order_type } = this.state;
    
        try {
            const response = await http.get("/rest/orderStatsHourlyExcel", {
                params: {
                    orderDate: StringUtil.formatKSTDate(orderDate),
                    startHour,
                    endHour,
                    order_gubun,
                    order_type
                },
                responseType: "blob"
            });
    
            const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
    
            // 파일명은 서버에서 지정된 fileNm.xls 또는 xlsx로 내려오는 게 이상적이지만, 여기선 기본값 지정
            let download_name = `로보MD_시간대별통계_${orderDate.toISOString().slice(0, 10)}.xlsx`;
            link.download =  ($(".pc_user_name").text() ? $(".pc_user_name").text() + "_": $(".mobile_user_name").text() ? $(".mobile_user_name").text() + "_" : "") + download_name;
            link.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("엑셀 다운로드 실패", error);
            alert("엑셀 다운로드에 실패했습니다.");
        }
    };

    handleSort = (gubun) => {
        const isSame = this.state.order_gubun === gubun;
        const nextOrderType = isSame && this.state.order_type === "ASC" ? "DESC" : "ASC";
    
        this.setState({
            order_gubun: gubun,
            order_type: nextOrderType
        }, this.loadHourlyStats);
    };

    render() {
        return (
            <>
                <div id='common-page-wrapper'>
                    <div id="list_wrap" class="style_guide_v2 rp_setting_page">
                        <section class="list_admin_wrap">
                            <div class="list_admin_main_board list_wrap_background" style={{
                                width: "100%",
                                height: "100%",
                                maxWidth: "100%",
                                // width: this.getPageStatus() === "init" ? maxRightTableWidth : null,
                                // maxWidth: this.getPageStatus() === "init" ? "100%" : null
                            }}>
                                    
                                    <div className="flexBox" style={{justifyContent:"space-between", alignItems:"center", marginBottom:"20px", gap: "13px"}}>
                                        <h4 style={{marginBottom: "0px"}}>쇼핑몰 시간별 통계</h4>
                                        <RpOrderHourStatisticsHourlyFilter  onChange={(filters) => this.handleFilterChange(filters)}/>
                                    </div>
                                    
                                    {/* 상품 목록 테이블 시작 */}
                                    <div className={"list_main_board_table_wrap"} id={"list_main_board_table_wrap"} ref={this.list_main_board_table_wrap} style={{maxHeight:"100%", backgroundColor:"white", padding:"15px", overflow:"hidden"}}>
                                        <div style={{float:"left", marginTop: "-4px", marginBottom:"10px", fontSize:"13px", fontWeight:"500"}}>
                                        ※ 각 시간은 해당 시각부터 3시간 동안의 데이터입니다.<br/>예: 0시는 0:00 ~ 2:59, 3시는 3:00 ~ 5:59 기준입니다.
                                        </div>
                                        <button className='common_button hover_mint'
                                        style={{float:"right", width:"90px", height:"30px", marginBottom:"10px", fontSize:"14px", fontWeight:"600"}}
                                        onClick={() => {this.downloadOrderStatsHourlyExcel()}}>
                                            다운로드
                                        </button>
                                        <div className="list_main_board_table_wrap" style={{overflow: "auto"}}>
                                            <table 
                                            className={"list_main_board_table rp_list_main_table rp_order_statistics_list_main_table"} 
                                            style={{width:"100%", height:"100%", tableLayout: "fixed"}}
                                            // style={{visibility: this.getPageStatus() != "init" ? "visible" : "hidden"}} 
                                            // onLoad={e => this.onLoadMainTable()}
                                            >
                                                <colgroup>
                                                    <col/>
                                                    <col style={{width: "120px"}}/>
                                                    <col style={{width: "100px"}}/>
                                                    <col style={{width: "190px"}}/>
                                                </colgroup>
                                                <thead>
                                                    <tr>
                                                        <th className="list_main_td stats_hour" onClick={() => this.handleSort("order_hour")}>
                                                            시간
                                                            <span style={{marginLeft:"3px"}}>
                                                                {this.state.order_gubun === "order_hour" && this.state.order_type === "ASC" && (
                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g transform="rotate(90 12 12)">
                                                                            <path d="M21.0001 12C21.0001 12.1989 20.9211 12.3897 20.7804 12.5303C20.6398 12.671 20.449 12.75 20.2501 12.75H5.56041L11.0307 18.2194C11.1004 18.289 11.1557 18.3718 11.1934 18.4628C11.2311 18.5539 11.2505 18.6514 11.2505 18.75C11.2505 18.8485 11.2311 18.9461 11.1934 19.0372C11.1557 19.1282 11.1004 19.2109 11.0307 19.2806C10.961 19.3503 10.8783 19.4056 10.7873 19.4433C10.6962 19.481 10.5986 19.5004 10.5001 19.5004C10.4016 19.5004 10.304 19.481 10.2129 19.4433C10.1219 19.4056 10.0392 19.3503 9.96948 19.2806L3.21948 12.5306C3.14974 12.461 3.09443 12.3782 3.05668 12.2872C3.01894 12.1961 2.99951 12.0986 2.99951 12C2.99951 11.9014 3.01894 11.8038 3.05668 11.7128C3.09443 11.6217 3.14974 11.539 3.21948 11.4694L9.96948 4.71936C10.1102 4.57863 10.3011 4.49957 10.5001 4.49957C10.6991 4.49957 10.89 4.57863 11.0307 4.71936C11.1715 4.8601 11.2505 5.05097 11.2505 5.24999C11.2505 5.44901 11.1715 5.63988 11.0307 5.78061L5.56041 11.25H20.2501C20.449 11.25 20.6398 11.329 20.7804 11.4697C20.9211 11.6103 21.0001 11.8011 21.0001 12Z" fill="#333333"/>
                                                                        </g>
                                                                    </svg>
                                                                )}
                                                                {this.state.order_gubun === "order_hour" && this.state.order_type === "DESC" && (
                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g transform="rotate(-90 12 12)">
                                                                            <path d="M21.0001 12C21.0001 12.1989 20.9211 12.3897 20.7804 12.5303C20.6398 12.671 20.449 12.75 20.2501 12.75H5.56041L11.0307 18.2194C11.1004 18.289 11.1557 18.3718 11.1934 18.4628C11.2311 18.5539 11.2505 18.6514 11.2505 18.75C11.2505 18.8485 11.2311 18.9461 11.1934 19.0372C11.1557 19.1282 11.1004 19.2109 11.0307 19.2806C10.961 19.3503 10.8783 19.4056 10.7873 19.4433C10.6962 19.481 10.5986 19.5004 10.5001 19.5004C10.4016 19.5004 10.304 19.481 10.2129 19.4433C10.1219 19.4056 10.0392 19.3503 9.96948 19.2806L3.21948 12.5306C3.14974 12.461 3.09443 12.3782 3.05668 12.2872C3.01894 12.1961 2.99951 12.0986 2.99951 12C2.99951 11.9014 3.01894 11.8038 3.05668 11.7128C3.09443 11.6217 3.14974 11.539 3.21948 11.4694L9.96948 4.71936C10.1102 4.57863 10.3011 4.49957 10.5001 4.49957C10.6991 4.49957 10.89 4.57863 11.0307 4.71936C11.1715 4.8601 11.2505 5.05097 11.2505 5.24999C11.2505 5.44901 11.1715 5.63988 11.0307 5.78061L5.56041 11.25H20.2501C20.449 11.25 20.6398 11.329 20.7804 11.4697C20.9211 11.6103 21.0001 11.8011 21.0001 12Z" fill="#333333"/>
                                                                        </g>
                                                                    </svg>
                                                                )}
                                                            </span>
                                                        </th>
                                                        <th className="list_main_td stats_order_price" onClick={() => this.handleSort("current_amount")}>
                                                            매출액
                                                            <span style={{marginLeft:"3px"}}>
                                                                {this.state.order_gubun === "current_amount" && this.state.order_type === "ASC" && (
                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g transform="rotate(90 12 12)">
                                                                            <path d="M21.0001 12C21.0001 12.1989 20.9211 12.3897 20.7804 12.5303C20.6398 12.671 20.449 12.75 20.2501 12.75H5.56041L11.0307 18.2194C11.1004 18.289 11.1557 18.3718 11.1934 18.4628C11.2311 18.5539 11.2505 18.6514 11.2505 18.75C11.2505 18.8485 11.2311 18.9461 11.1934 19.0372C11.1557 19.1282 11.1004 19.2109 11.0307 19.2806C10.961 19.3503 10.8783 19.4056 10.7873 19.4433C10.6962 19.481 10.5986 19.5004 10.5001 19.5004C10.4016 19.5004 10.304 19.481 10.2129 19.4433C10.1219 19.4056 10.0392 19.3503 9.96948 19.2806L3.21948 12.5306C3.14974 12.461 3.09443 12.3782 3.05668 12.2872C3.01894 12.1961 2.99951 12.0986 2.99951 12C2.99951 11.9014 3.01894 11.8038 3.05668 11.7128C3.09443 11.6217 3.14974 11.539 3.21948 11.4694L9.96948 4.71936C10.1102 4.57863 10.3011 4.49957 10.5001 4.49957C10.6991 4.49957 10.89 4.57863 11.0307 4.71936C11.1715 4.8601 11.2505 5.05097 11.2505 5.24999C11.2505 5.44901 11.1715 5.63988 11.0307 5.78061L5.56041 11.25H20.2501C20.449 11.25 20.6398 11.329 20.7804 11.4697C20.9211 11.6103 21.0001 11.8011 21.0001 12Z" fill="#333333"/>
                                                                        </g>
                                                                    </svg>
                                                                )}
                                                                {this.state.order_gubun === "current_amount" && this.state.order_type === "DESC" && (
                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g transform="rotate(-90 12 12)">
                                                                            <path d="M21.0001 12C21.0001 12.1989 20.9211 12.3897 20.7804 12.5303C20.6398 12.671 20.449 12.75 20.2501 12.75H5.56041L11.0307 18.2194C11.1004 18.289 11.1557 18.3718 11.1934 18.4628C11.2311 18.5539 11.2505 18.6514 11.2505 18.75C11.2505 18.8485 11.2311 18.9461 11.1934 19.0372C11.1557 19.1282 11.1004 19.2109 11.0307 19.2806C10.961 19.3503 10.8783 19.4056 10.7873 19.4433C10.6962 19.481 10.5986 19.5004 10.5001 19.5004C10.4016 19.5004 10.304 19.481 10.2129 19.4433C10.1219 19.4056 10.0392 19.3503 9.96948 19.2806L3.21948 12.5306C3.14974 12.461 3.09443 12.3782 3.05668 12.2872C3.01894 12.1961 2.99951 12.0986 2.99951 12C2.99951 11.9014 3.01894 11.8038 3.05668 11.7128C3.09443 11.6217 3.14974 11.539 3.21948 11.4694L9.96948 4.71936C10.1102 4.57863 10.3011 4.49957 10.5001 4.49957C10.6991 4.49957 10.89 4.57863 11.0307 4.71936C11.1715 4.8601 11.2505 5.05097 11.2505 5.24999C11.2505 5.44901 11.1715 5.63988 11.0307 5.78061L5.56041 11.25H20.2501C20.449 11.25 20.6398 11.329 20.7804 11.4697C20.9211 11.6103 21.0001 11.8011 21.0001 12Z" fill="#333333"/>
                                                                        </g>
                                                                    </svg>
                                                                )}
                                                            </span>
                                                        </th>
                                                        <th className="list_main_td stats_order_cnt" onClick={() => this.handleSort("current_count")}>
                                                            구매건수
                                                            <span style={{marginLeft:"3px"}}>
                                                                {this.state.order_gubun === "current_count" && this.state.order_type === "ASC" && (
                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g transform="rotate(90 12 12)">
                                                                            <path d="M21.0001 12C21.0001 12.1989 20.9211 12.3897 20.7804 12.5303C20.6398 12.671 20.449 12.75 20.2501 12.75H5.56041L11.0307 18.2194C11.1004 18.289 11.1557 18.3718 11.1934 18.4628C11.2311 18.5539 11.2505 18.6514 11.2505 18.75C11.2505 18.8485 11.2311 18.9461 11.1934 19.0372C11.1557 19.1282 11.1004 19.2109 11.0307 19.2806C10.961 19.3503 10.8783 19.4056 10.7873 19.4433C10.6962 19.481 10.5986 19.5004 10.5001 19.5004C10.4016 19.5004 10.304 19.481 10.2129 19.4433C10.1219 19.4056 10.0392 19.3503 9.96948 19.2806L3.21948 12.5306C3.14974 12.461 3.09443 12.3782 3.05668 12.2872C3.01894 12.1961 2.99951 12.0986 2.99951 12C2.99951 11.9014 3.01894 11.8038 3.05668 11.7128C3.09443 11.6217 3.14974 11.539 3.21948 11.4694L9.96948 4.71936C10.1102 4.57863 10.3011 4.49957 10.5001 4.49957C10.6991 4.49957 10.89 4.57863 11.0307 4.71936C11.1715 4.8601 11.2505 5.05097 11.2505 5.24999C11.2505 5.44901 11.1715 5.63988 11.0307 5.78061L5.56041 11.25H20.2501C20.449 11.25 20.6398 11.329 20.7804 11.4697C20.9211 11.6103 21.0001 11.8011 21.0001 12Z" fill="#333333"/>
                                                                        </g>
                                                                    </svg>
                                                                )}
                                                                {this.state.order_gubun === "current_count" && this.state.order_type === "DESC" && (
                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g transform="rotate(-90 12 12)">
                                                                            <path d="M21.0001 12C21.0001 12.1989 20.9211 12.3897 20.7804 12.5303C20.6398 12.671 20.449 12.75 20.2501 12.75H5.56041L11.0307 18.2194C11.1004 18.289 11.1557 18.3718 11.1934 18.4628C11.2311 18.5539 11.2505 18.6514 11.2505 18.75C11.2505 18.8485 11.2311 18.9461 11.1934 19.0372C11.1557 19.1282 11.1004 19.2109 11.0307 19.2806C10.961 19.3503 10.8783 19.4056 10.7873 19.4433C10.6962 19.481 10.5986 19.5004 10.5001 19.5004C10.4016 19.5004 10.304 19.481 10.2129 19.4433C10.1219 19.4056 10.0392 19.3503 9.96948 19.2806L3.21948 12.5306C3.14974 12.461 3.09443 12.3782 3.05668 12.2872C3.01894 12.1961 2.99951 12.0986 2.99951 12C2.99951 11.9014 3.01894 11.8038 3.05668 11.7128C3.09443 11.6217 3.14974 11.539 3.21948 11.4694L9.96948 4.71936C10.1102 4.57863 10.3011 4.49957 10.5001 4.49957C10.6991 4.49957 10.89 4.57863 11.0307 4.71936C11.1715 4.8601 11.2505 5.05097 11.2505 5.24999C11.2505 5.44901 11.1715 5.63988 11.0307 5.78061L5.56041 11.25H20.2501C20.449 11.25 20.6398 11.329 20.7804 11.4697C20.9211 11.6103 21.0001 11.8011 21.0001 12Z" fill="#333333"/>
                                                                        </g>
                                                                    </svg>
                                                                )}
                                                            </span>
                                                        </th>
                                                        <th className="list_main_td stats_order_diff flexBox" style={{justifyContent:"right"}} onClick={() => this.handleSort("percent_diff")}>
                                                            <span className="flexBox" style={{alignItems:"center"}}>
                                                                <span style={{marginRight:"3px"}}>매출지표분석</span>
                                                                <span onClick={(e) => {e.stopPropagation();}}>
                                                                    <Tooltip squareMoveLeft={40} content={"전주 동일 요일과 비교한 매출 차이 및 증감률을 표시합니다."}/>
                                                                </span>
                                                            </span>
                                                            <span>
                                                                {this.state.order_gubun === "percent_diff" && this.state.order_type === "ASC" && (
                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g transform="rotate(90 12 12)">
                                                                            <path d="M21.0001 12C21.0001 12.1989 20.9211 12.3897 20.7804 12.5303C20.6398 12.671 20.449 12.75 20.2501 12.75H5.56041L11.0307 18.2194C11.1004 18.289 11.1557 18.3718 11.1934 18.4628C11.2311 18.5539 11.2505 18.6514 11.2505 18.75C11.2505 18.8485 11.2311 18.9461 11.1934 19.0372C11.1557 19.1282 11.1004 19.2109 11.0307 19.2806C10.961 19.3503 10.8783 19.4056 10.7873 19.4433C10.6962 19.481 10.5986 19.5004 10.5001 19.5004C10.4016 19.5004 10.304 19.481 10.2129 19.4433C10.1219 19.4056 10.0392 19.3503 9.96948 19.2806L3.21948 12.5306C3.14974 12.461 3.09443 12.3782 3.05668 12.2872C3.01894 12.1961 2.99951 12.0986 2.99951 12C2.99951 11.9014 3.01894 11.8038 3.05668 11.7128C3.09443 11.6217 3.14974 11.539 3.21948 11.4694L9.96948 4.71936C10.1102 4.57863 10.3011 4.49957 10.5001 4.49957C10.6991 4.49957 10.89 4.57863 11.0307 4.71936C11.1715 4.8601 11.2505 5.05097 11.2505 5.24999C11.2505 5.44901 11.1715 5.63988 11.0307 5.78061L5.56041 11.25H20.2501C20.449 11.25 20.6398 11.329 20.7804 11.4697C20.9211 11.6103 21.0001 11.8011 21.0001 12Z" fill="#333333"/>
                                                                        </g>
                                                                    </svg>
                                                                )}
                                                                {this.state.order_gubun === "percent_diff" && this.state.order_type === "DESC" && (
                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g transform="rotate(-90 12 12)">
                                                                            <path d="M21.0001 12C21.0001 12.1989 20.9211 12.3897 20.7804 12.5303C20.6398 12.671 20.449 12.75 20.2501 12.75H5.56041L11.0307 18.2194C11.1004 18.289 11.1557 18.3718 11.1934 18.4628C11.2311 18.5539 11.2505 18.6514 11.2505 18.75C11.2505 18.8485 11.2311 18.9461 11.1934 19.0372C11.1557 19.1282 11.1004 19.2109 11.0307 19.2806C10.961 19.3503 10.8783 19.4056 10.7873 19.4433C10.6962 19.481 10.5986 19.5004 10.5001 19.5004C10.4016 19.5004 10.304 19.481 10.2129 19.4433C10.1219 19.4056 10.0392 19.3503 9.96948 19.2806L3.21948 12.5306C3.14974 12.461 3.09443 12.3782 3.05668 12.2872C3.01894 12.1961 2.99951 12.0986 2.99951 12C2.99951 11.9014 3.01894 11.8038 3.05668 11.7128C3.09443 11.6217 3.14974 11.539 3.21948 11.4694L9.96948 4.71936C10.1102 4.57863 10.3011 4.49957 10.5001 4.49957C10.6991 4.49957 10.89 4.57863 11.0307 4.71936C11.1715 4.8601 11.2505 5.05097 11.2505 5.24999C11.2505 5.44901 11.1715 5.63988 11.0307 5.78061L5.56041 11.25H20.2501C20.449 11.25 20.6398 11.329 20.7804 11.4697C20.9211 11.6103 21.0001 11.8011 21.0001 12Z" fill="#333333"/>
                                                                        </g>
                                                                    </svg>
                                                                )}
                                                            </span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody id="main_table_tbody" style={{maxHeight:"100%"}}>
                                                        {
                                                            this.state.list && this.state.list.map((value, index) => 
                                                                {
                                                                return (
                                                                <tr
                                                                style={{
                                                                    height: "600 !important",
                                                                    overflowY: 'scroll !important',
                                                                    overflowX: 'hidden !important',
                                                                }}
                                                                key={value.product_no}
                                                                tabIndex={-1} >
                                                                    <td className={"stats_hour"}>
                                                                    {value.order_hour+"시"}
                                                                    </td>
                                                                    <td className={"stats_order_price"}>
                                                                    {StringUtil.numberComma(value.current_amount)}
                                                                    </td>
                                                                    <td className={"stats_order_cnt"}>
                                                                    {StringUtil.numberComma(value.current_count)}
                                                                    </td>
                                                                    <td className={"stats_order_diff flexBox"} style={{justifyContent: "right"}}>
                                                                    {StringUtil.numberComma(value.amount_diff)}
                                                                        {value.percent_diff && value.percent_diff !== "-" ? (
                                                                            <>
                                                                            {" (" + StringUtil.numberComma(value.percent_diff) + "% "}
                                                                            <div style={{ color: (value.amount_diff == 0 ? "#3A3A3A" : value.amount_diff < 0 ? "blue" : "red"), marginLeft: "5px" }}>
                                                                                {value.amount_diff == 0 ? "유지" : value.amount_diff < 0 ? "감소" : "증가"}
                                                                            </div>
                                                                            {")"}
                                                                            </>
                                                                        ) : (
                                                                            " (-)"
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            )
                                                                }
                                                            
                                                            )
                                                        }
                                                    </tbody>
                                            </table>
                                        </div>
                                        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", height:"40px", backgroundColor:"#B9DDFF", fontSize:"14px", lineHeight:"1", padding: "10px", fontWeight:"600"}}>
                                            <div>총 매출합계</div>
                                            <div>{StringUtil.numberComma(this.state.totalAmount)}원</div>
                                        </div>
                                    </div>
                                </div>
                        </section>
                    </div>
                </div>
                {/* 왼쪽 또는 오른쪽 영역 저장시 나오는 다이얼로그 */
					(this.state.save_dialog_show_state === true)
					? <SaveDialogV2
						content={this.state.save_dialog_content}
						button_list={this.state.save_dialog_button_list}
					/>
					: ''
				}
                {/* 기본 안내 다이얼로그 */
					(this.state.basic_dialog_show_state === true)
					? <BasicDialogV2
						content={this.state.basic_dialog_content}
						button_list={this.state.basic_dialog_button_list}
                        width= {this.state.basic_dialog_width}
					/>
					: ''
				}
                {/* 오른쪽 영역 초기화 다이얼로그*/
					(this.state.title_content_dialog_show_state === true)
					? <TitleContentDialogV2
                        title={this.state.title_content_dialog_title}
						content={this.state.title_content_dialog_content}
						button_list={this.state.title_content_dialog_button_list}
                        check_box_text={this.state.title_content_dialog_check_box_text}
                        check_box_checked={this.state.title_content_dialog_check_box_checked}
                        onChangeCheckBox={this.onChangeTitleContentCheckBox}
						popup_close={() => {
                            this.setState({title_content_dialog_show_state: false});
                        }}
					/>
					: ''
				}
                {/* 확인 취소 다이얼로그 */
					(this.state.confirm_dialog_show_state === true)
					? <ConfirmDialogV2
						content={this.state.confirm_dialog_content}
						content2={this.state.confirm_dialog_content2}
						button_list={this.state.confirm_dialog_button_list}
						popup_close={() => {
                            this.setState({
                                confirm_dialog_show_state: false,
                                confirm_dialog_content2 : null,
                            });
                        }}
					/>
					: ''
				}
                {/* 선정된 상품목록 적용하기 : 뒷 스크롤 계속 막아야함 */
					(this.state.paste_confirm_dialog_show_state === true)
					? <ConfirmDialogV2
						content={this.state.confirm_dialog_content}
						button_list={this.state.confirm_dialog_button_list}
						popup_close={() => {
                            this.setState({paste_confirm_dialog_show_state: false});
                        }}
					/>
					: ''
				}
                {/* 상품 연동 다이얼로그 */
					(this.state.refresh_data_show_state === true)
					? <TitleContentDialogV2
                        title={"상품 목록을 새로 불러오시겠습니까?"}
						content={'<p style="word-break:keep-all;">상품 수에 따라 짧게는 몇 분에서 길게는 몇 시간이 걸릴 수 있습니다.</br>' +
                        "그 동안 다른 기능들은 모두 정상적으로 이용하실 수 있습니다.</p>"}
						button_list={[
                            {
                                title:"네",
                                event_method: () => {
                                    this.fn_refreshDataSync();
                                    this.setState({refresh_data_show_state : false});
                                }
                            },
                            {
                                title: "아니요",
                                event_method: () => {
                                    //팝업 닫기
                                    this.setState({refresh_data_show_state : false});
                                }
                            },
                        ]}
						popup_close={() => {
                            this.setState({refresh_data_show_state: false});
                        }}
					/>
					: ''
				}
                {
                    /* Warning Dialog */
                    this.state.warning_state &&
                    <WarningDialog
                        content={this.state.warning_message}
                        button_list={[{
                                    title : "확인",
                                    event_method : () => { this.handleToggle("warning_state") }
                            }]}
                        popup_close={() => this.handleToggle("warning_state")}
                        width="auto"
                    />
                }
                {/* 실시간 관리 신청 다이얼로그 */
					(this.state.real_time_service_regist_show_state == true)
					? <TitleContentDialogV2
                        title={"<img src='https://s3.ap-northeast-2.amazonaws.com/otdeal.file/icn_robomd.png' style='width:100px;height:auto;'/>"}
						content={'<p style="word-break:keep-all;">실시간관리는 실시간 유료서비스를</br>등록하셔야 사용이 가능합니다.</br>실시간 상세 기능 설명을 보러 가시겠습니까?</p>'}
						button_list={[
                            {
                                title:"네",
                                event_method: () => {
                                    window.open("/shop/rp/realTimeService");
                                    this.setState({real_time_service_regist_show_state : false});
                                }
                            },
                            {
                                title: "아니요",
                                event_method: () => {
                                    //팝업 닫기
                                    this.setState({real_time_service_regist_show_state : false});
                                }
                            },
                        ]}
						popup_close={() => {
                            this.setState({real_time_service_regist_show_state: false});
                        }}
					/>
					: ''
				}
                {/* 입력 다이얼로그 */
                    (this.state.input_dialog_show_state === true)
                    ? <InputDialogV2
                        title={this.state.input_dialog_title}
                        content={this.state.input_dialog_content}
                        input_value={this.state.input_dialog_input_value}
                        input_placeholder={this.state.input_dialog_input_placeholder}
                        button_list={this.state.input_dialog_button_list}
                        popup_close={() => {
                            this.setState({input_dialog_show_state: false});
                        }}
                    />
                    : ''
                }
            </>
        )
    };
}